import { Typography } from '@mui/material'
import { useContext } from 'react'

import { StatsContext } from '../../Contexts'
import { Property } from '../Property'

const TotalBiddersProperty: React.FC = () => {
  const { totalBidders } = useContext(StatsContext)
  return (
    <Property title="Total Bidders" value={totalBidders}>
      <Typography variant="caption">{totalBidders}</Typography>
    </Property>
  )
}

export default TotalBiddersProperty
